export default __webpack_public_path__ + "static/media/aluminum-cobra-single-phase.d53c9c85.png";